module.exports = __webpack_public_path__ + "static/img/main_top_2_1.434e04a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/main_top_2_1.png
// module id = pGIX
// module chunks = 1